import React, { useState } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Box,
  IconButton,
  styled,
} from "@mui/material";
import CustomCheckbox from "./Checkbox";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import MenuWithPDF from "../filter/MenuWithPDF";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Avatar1 } from "../../assets/Avatar1.svg";
import dayjs from "dayjs";
import {
  deleteCantine,
  duplicateCantineAsync,
  fetchCantinesById,
  fetchProductionTypes,
} from "../../features/cantine/cantineThunk";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTerreni,
  fetchEsposizione,
  fetchSingleTerreni,
  fetchSistemaColtivazione,
  fetchTipoSuolo,
} from "../../features/terreni/terreniThunk";
import { deleteStabilimento, fetchSingleStabilimento } from "../../features/stabilimenti/stabilimentiThunk";
import { deleteProdotto } from "../../features/Prodotti/prodottiSlice";
import { singleProdotti } from "../../features/Prodotti/prodottiThunk";
// import { deleteSensore } from "../../features/sensori/sensoriThunk";
import { deleteSensore, fetchSingleSensore } from "../../features/sensori/sensoriThunk";
import { deleteMezziData, singleMezzi } from "../../features/Mezzi/mezziThunk";
import { deleteManutenzioneData, singleManutenzione } from "../../features/manutenzione/manutenzioneThunk";
import { deleteParticelleByID, fetchSingleParticelle } from "../../features/particelle/particelleThunk";
import { deleteTrattamentiByID, fetchSingleTrattamenti } from "../../features/trattamenti/trattamentiThunk";
// import { deleteDocumentiData } from "../../features/documenti/doucumentiThunk";
import { deleteDocumentiData, singleDocumenti } from "../../features/documenti/documentiThunk";
import { deleteAttrezzatureByID, fetchSingleAttrezzatture } from "../../features/attrezzatura/attrezzaturaThunk";
import { singleGiacenza } from "../../features/giacenze/giacenzeThunk";
import { singleTrasporti } from "../../features/trasporti/trasportiThunk";
import { deleteOperatoriData, singleOperatori } from "../../features/operatori/operatoriThunk";
import { deleteProduzioneTrattamentiByID, fetchSingleProduzioneTrattamenti } from "../../features/produzione-trattamenti/produzione-trattamentiThunk";
import { selectOperatori } from "../../features/operatori/operatoriSlice";
import { selectTerreni } from "../../features/terreni/terreniSlice";
import { setSingleProduzioneId } from "../../features/produzioni/produzioniSlice";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: "12px 16px",
  fontSize: "0.875rem",
  borderBottom: "1px solid #e0e0e0",
  color: theme.palette.text.secondary,
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#fafafa",
  },
  cursor: "pointer",
}));




const getStatusColor = (stato) => {
  switch (stato) {
    case "Approvato":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "approvatoStato",
      };
    case "Completato":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "completatoStato",
      };
    case "In Attesa":
      return {
        backgroundColor: "#FFF8E1",
        color: "#FFB300",
        className: "in-attesaStato",
      };
    case "Rifiutato":
      return {
        backgroundColor: "#FFEBEE",
        color: "#F44336",
        className: "rifiutatoStato",
      };
    case "Da contattare":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "completatoStato",
      };
    case "Contattati":
      return {
        backgroundColor: "orange",
        color: "white",
        className: "in-attesaStato",
      };
    case "In trattativa":
      return {
        backgroundColor: "red",
        color: "#fff",
        className: "rifiutatoStato",
      };
    case "Attivo":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "Attivo",
      };
    case "Saldato":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "Attivo",
      };
    case "Pagata":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "Attivo",
      };
    case "Immediata":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "Immediata",
      };
    case "Approvata":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "Approvata",
      };
    case "SI":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "Approvata",
      };
    case "Completa":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "Approvata",
      };
    case "Regolari":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "Approvata",
      };
    case "Disponibile":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "Approvata",
      };
    case "In corso":
      return {
        backgroundColor: "#FFA90333",
        color: "#FFA903",
        className: "defaultStato",
      };
    case "Consolidato":
      return {
        backgroundColor: "#57C70033",
        color: "#57C700",
        className: "Approvata",
      };
    default:
      return {
        backgroundColor: "#F5F5F5",
        color: "#9E9E9E",
        className: "defaultStato",
      };
  }
};

const StatusChip = styled(Box)(({ stato }) => {
  const { backgroundColor, color } = getStatusColor(stato);

  return {
    padding: "2px 8px",
    borderRadius: "6px",
    fontSize: "12px",
    lineHeight: "20px",
    display: "inline-block",
    fontWeight: "bold",
    backgroundColor,
    color,
    transition: "all 0.3s ease",
  };
});

const TableRows = ({
  data,
  page,
  rowsPerPage,
  isSelected,
  handleRowClick,
  handleStatusClick,
  currentStatuses,
  searchFilters,
  option,
  form,
  navData,
}) => {
  // const dispatch = useDispatch(); // Dispatch hook
  const operatri = useSelector(selectOperatori);
  const prodotti = useSelector((state) => state.prodotto?.prodotti);
  const navigate = useNavigate();
  const [dataState, setDataState] = useState(data || []);
  const location = useLocation();
  const terreni = useSelector(selectTerreni)
  const handleInputChange = (newValue, index, field) => {
    // console.log(newValue, index, field, "newValue, index, field");
    const updatedData = [...dataState];

    // Format the date as DD/MM/YYYY if newValue is a valid Day.js object
    const value = newValue ? dayjs(newValue).format("DD/MM/YYYY") : null;

    updatedData[index][field] = value;
    setDataState(updatedData);
  };

  const dispatch = useDispatch();


  const handleDelete = (id, type) => {
    // console.log("Deleting ID:", id);
    // switch (type) {
    //   case "cantine":
    //     dispatch(deleteCantine(id));
    //     break;
    //   case "terreni":
    //     dispatch(deleteTerreni(id));
    //     break;
    //   case "prodotti":
    //     dispatch(deleteProdotto(id));
    //     break;
    //   case "stabilimenti":
    //     dispatch(deleteStabilimento(id));
    //     break;
    //   case "sensori":
    //     dispatch(deleteSensore(id));
    //     break;
    //   case "structureGiacenze":
    //     dispatch(deleteSensore(id));
    //     break;
    //   case "structureMezzi":
    //     dispatch(deleteMezziData(id));
    //     break;
    //   case "manutenzioneLogistica":
    //     dispatch(deleteManutenzioneData(id));
    //     break;
    //   case "documenti":
    //     dispatch(deleteDocumentiData(id));
    //     break;
    //     case "operatori":
    //     dispatch(deleteOperatoriData(id));
    //     break;
    //   case "trasproto":
    //     // dispatch(deleteTrasportoData(id));
    //     break;
    //     case "attrezzature":
    //       dispatch(deleteAttrezzatureByID(id));
    //       break;
    //       case "particelle":
    //         dispatch(deleteParticelleByID(id));
    //         break;
    //         case "trretmenti":
    //           dispatch(deleteTrattamentiByID(id));
    //           break;
    //           case "produzione-trretmenti":
    //             dispatch(deleteProduzioneTrattamentiByID(id));
    //             break;
    //   default:
    //     break;
    // }
  };

  const handleDuplicate = (id) => {
    console.log("Duplicating ID:", id);
    if (window.confirm("Are you sure you want to Duplicate this item?")) {
      dispatch(duplicateCantineAsync(id));
    }
  };
  const singleData = (id, type) => {
    console.log("type123:", type);
    switch (type) {
      case "cantine":
        dispatch(fetchCantinesById(id));
        dispatch(fetchProductionTypes(id));
        break;
      case "terreni":
        dispatch(fetchSingleTerreni(id));
        dispatch(fetchEsposizione(id));
        dispatch(fetchTipoSuolo(id));
        dispatch(fetchSistemaColtivazione(id));
        break;
      case "stabilimenti":
        dispatch(fetchSingleStabilimento(id));
        break;
      case "prodotti":
        dispatch(singleProdotti(id));
        break;
      case "sensore":
        dispatch(fetchSingleSensore(id));
        break;
      case "trasporti":
        dispatch(fetchSingleSensore(id));
        break;
      case "mezzi":
        console.log("Fetching singleData for ID:", id);
        dispatch(singleMezzi(id));
        break;
      case "particelle":
        dispatch(fetchSingleParticelle(id));
        break;
      case "trattamenti":
        dispatch(fetchSingleTrattamenti(id));
        break;
      case "attrezzature":
        dispatch(fetchSingleAttrezzatture(id));
        break;
      case "manutenzione":
        dispatch(singleManutenzione(id));
        break;
      case "stabilimentiLogistica":
        dispatch(fetchSingleStabilimento(id));
        break;
      case "transport":
        dispatch(singleTrasporti(id));
        break;
      case "documenti":
        dispatch(singleDocumenti(id));
        break;
      case "operatori":
        dispatch(singleOperatori(id));
        break;
      case "structureGiacenze":
        dispatch(singleGiacenza(id))
        break;
      case "produzione-trretmenti":
        dispatch(fetchSingleProduzioneTrattamenti(id))
        break;
      case "produzioni":
        dispatch(setSingleProduzioneId(id));
        break;
      default:
        break;
    }
  };

  const dataRender = (navData) => {
    switch (navData) {
      case "cantine":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      navigate("/strutture/cantine/Terreni");
                      singleData(row?.id, "cantine");
                      localStorage.setItem("cantine_id", row?.id);
                    }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.nomeCantina}</StyledTableCell>
                    <StyledTableCell>{Array.isArray(row?.tipo) ? row.tipo.join(', ') : row?.tipo || ''}</StyledTableCell>
                    <StyledTableCell>{row.civico}</StyledTableCell>
                    <StyledTableCell>{row.via}</StyledTableCell>
                    <StyledTableCell>{row.regione}</StyledTableCell>
                    <StyledTableCell>{row.cap}</StyledTableCell>
                    <StyledTableCell>{row.pr}</StyledTableCell>
                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row.id, "cantine")}
                        handleDuplicate={handleDuplicate}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
      case "terreni":
        const isTerreniPage = window.location.href.includes(
          "/strutture/cantine/Terreni"
        );
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      navigate("/strutture/terreni/Particelle");
                      singleData(row?.id, "terreni");
                      localStorage.setItem("terreni_id", row?.id);
                    }}
                  >
                    {!isTerreniPage && (
                      <StyledTableCell align="center">
                        {console.log("irrigazionerow", row.irrigazione)}
                        <CustomCheckbox
                          className="customChechbox"
                          color="primary"
                          checked={isSelected(row.id)}
                          onChange={(event) => handleRowClick(event, row.id)}
                          onClick={(event) => event.stopPropagation()}
                          inputProps={{ "aria-labelledby": row.id }}
                        />
                      </StyledTableCell>
                    )}
                    <StyledTableCell>{row.nome}</StyledTableCell>
                    {/* <StyledTableCell>{row.tipologiaTerreno}</StyledTableCell> */}
                    <StyledTableCell>{row.superficie_totale}</StyledTableCell>
                    <StyledTableCell>
                      {row.superficie_coltivata}
                    </StyledTableCell>
                    {/* {!isTerreniPage && (
                      <StyledTableCell>{row.percentSupColtivata}</StyledTableCell>
                    )} */}
                    <StyledTableCell>{row.altitudine}</StyledTableCell>
                    <StyledTableCell>{row.esposizione}</StyledTableCell>
                    <StyledTableCell>{row.tipo_suolo}</StyledTableCell>
                    <StyledTableCell>{row.irrigazione ? "Si" : "No"}</StyledTableCell>
                    <StyledTableCell>
                      {row.sistema_coltivazione}
                    </StyledTableCell>
                    <StyledTableCell>{row.coordinate_gps}</StyledTableCell>
                    <StyledTableCell
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row.id, "terreni")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
      case "subParticelle":
        const isParticellePage = window.location.href.includes(
          "/strutture/terreni/Particelle"
        );
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => { singleData(row?.id, "particelle"); navigate(""); localStorage.setItem("particelle", true) }}
                    >
                    {!isParticellePage && (
                      <StyledTableCell align="center">
                        <CustomCheckbox
                          className="customChechbox"
                          color="primary"
                          checked={isSelected(row.id)}
                          onChange={(event) => handleRowClick(event, row.id)}
                          onClick={(event) => event.stopPropagation()}
                          inputProps={{ "aria-labelledby": row.id }}
                        />
                      </StyledTableCell>
                    )}
                    <StyledTableCell>{row.particle_id}</StyledTableCell>
                    <StyledTableCell>{row.terreni_id || "N/A"}</StyledTableCell>
                    <StyledTableCell>{row.codice_catastale}</StyledTableCell>
                    <StyledTableCell>{row.foglio_catastale}</StyledTableCell>
                    <StyledTableCell>{row.superficie}</StyledTableCell>
                    <StyledTableCell>{row.cultura}</StyledTableCell>
                    <StyledTableCell>{row.varieta}</StyledTableCell>
                    <StyledTableCell>{row.densita}</StyledTableCell>
                    <StyledTableCell>{row.anno}</StyledTableCell>
                    <StyledTableCell>{row.certificazioni}</StyledTableCell>
                    <StyledTableCell
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row.id, "particelle")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
      case "subTrattamenti":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => { singleData(row?.id, "trattamenti"); navigate(""); location.pathname.includes("/strutture/terreni/Trattamenti") ? localStorage.setItem("trattamenti", true) : localStorage.setItem("open", true) }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.tipo_di_trattamento}</StyledTableCell>
                    <StyledTableCell>{terreni.find(item => item?.id === row?.terreno_id)?.nome || ''}</StyledTableCell>
                    <StyledTableCell>{row.particella_id}</StyledTableCell>
                    <StyledTableCell>{row.data_trattamento}</StyledTableCell>
                    <StyledTableCell>{row.prodotto_utilizzato}</StyledTableCell>
                    <StyledTableCell>{row.qty}</StyledTableCell>
                    <StyledTableCell>{row.applicazione}</StyledTableCell>
                    <StyledTableCell>{operatri.find(item => item?.id === row?.operatore_id)?.name || ''}</StyledTableCell>
                    <StyledTableCell>{row.intervallo_sicurezza}</StyledTableCell>
                    <StyledTableCell
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row.id, "trretmenti")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );


      case "structureStabilimenti":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      singleData(row?.id, "stabilimenti");
                      navigate("/strutture/stabiliment/Attrezzature");
                      localStorage.setItem("stabili_id", row?.id);
                    }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.nomeStabilimento}</StyledTableCell>
                    <StyledTableCell>{row.tipologia}</StyledTableCell>
                    <StyledTableCell>{row.supTotale}</StyledTableCell>
                    <StyledTableCell>{row.supCoperta}</StyledTableCell>
                    <StyledTableCell>{row.stoccaggio}</StyledTableCell>
                    <StyledTableCell>{row.impianti ? "Si" : "No"}</StyledTableCell>
                    <StyledTableCell>{row.coordinateGPS}</StyledTableCell>

                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row.id, "stablimenti")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
      case "structureAttrezzature":
        const isLogisticPage = window.location.href.includes(
          "/logistica/stabilimenti/Attrezzature"
        );
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      singleData(row?.id, "attrezzature");
                      navigate("");

                      isLogisticPage ? localStorage.setItem("logisticAttrezzature", true) :
                        localStorage.setItem("attrezzature", true)


                    }
                    }
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.attrezzatura}</StyledTableCell>
                    <StyledTableCell>{row.stabili_id || "N/A"}</StyledTableCell>
                    <StyledTableCell>{row.att_name || "NA"}</StyledTableCell>
                    <StyledTableCell>{row.modello || "N/A"}</StyledTableCell>
                    {/* <StyledTableCell>{}</StyledTableCell> */}
                    <StyledTableCell>{row.suprifice_coperta}</StyledTableCell>
                    <StyledTableCell>{row.suprificie_stoccaggio}</StyledTableCell>
                    <StyledTableCell>{row.ultima_date}</StyledTableCell>
                    <StyledTableCell>
                      {row.gps}
                    </StyledTableCell>
                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF options={option} id={row.id}
                        handleDelete={() => handleDelete(row.id, "attrezzature")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
      case "structureGiacenze":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      singleData(row?.id, "structureGiacenze");
                      navigate("");
                      localStorage.setItem("structureGiacenze", true);
                    }}
                  >
                    {/* {isGiacenzePage && ( */}
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    {/* )} */}
                    <StyledTableCell>{row.name}</StyledTableCell>
                    <StyledTableCell>{row.tipo}</StyledTableCell>
                    <StyledTableCell>{row.lotto}</StyledTableCell>
                    <StyledTableCell>{row.um}</StyledTableCell>
                    <StyledTableCell>{row.displonibile}</StyledTableCell>
                    <StyledTableCell>{row.data_ingresso}</StyledTableCell>
                    <StyledTableCell>{row.scadenza}</StyledTableCell>
                    <StyledTableCell align="center">
                      {/* {console.log("Row Status:", row.status)}
                      {console.log("Current Status:", currentStatuses?.[index])} */}
                      <StatusChip
                        stato={
                          searchFilters?.stato && row.stato
                            ? row.status
                            : currentStatuses?.[index] || row.stato || "Unknown"
                        }
                        className={
                          getStatusColor(
                            searchFilters?.stato && row.stato
                              ? row.status
                              : currentStatuses?.[index] || row.status || "Unknown"
                          )?.className || ""
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleStatusClick(index);
                        }}
                      >
                        {searchFilters?.stato && row.stato
                          ? row.stato
                          : currentStatuses?.[index] || row.stato || "Unknown"}
                      </StatusChip>
                    </StyledTableCell>

                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row.id, "structureGiacenze")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
      case "structureProdotti":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      navigate("/strutture/prodotti/Giacenze");
                      singleData(row?.id, "prodotti");
                      localStorage.setItem("product_id", row?.id);
                      // localStorage.setItem("prodottiGiacenze",true)
                    }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.nomeProdotto}</StyledTableCell>
                    <StyledTableCell>{row.tipo}</StyledTableCell>
                    <StyledTableCell>{row.tipologia}</StyledTableCell>
                    <StyledTableCell>{row.annoProduzione}</StyledTableCell>
                    <StyledTableCell>{row.gradazioneAlcolica}</StyledTableCell>
                    <StyledTableCell>{row.cod}</StyledTableCell>
                    <StyledTableCell>{row.codEan}</StyledTableCell>
                    <StyledTableCell>{row.denominazione}</StyledTableCell>
                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row.id, "prodotto")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );

      case "strucutreSensori":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      navigate("/strutture/sensori/Location");
                      singleData(row?.id, "sensore");
                    }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.sensore_name}</StyledTableCell>
                    <StyledTableCell>{row.sensore_tipo}</StyledTableCell>
                    <StyledTableCell>{row.modelllo}</StyledTableCell>
                    <StyledTableCell>{row.matricola}</StyledTableCell>
                    <StyledTableCell>{row.sensore_gps}</StyledTableCell>
                    <StyledTableCell>{row.data_installazione}</StyledTableCell>
                    <StyledTableCell>{row.ultimo_agginornamento}</StyledTableCell>
                    <StyledTableCell>{row.stato || row.status}</StyledTableCell>
                    <StyledTableCell
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row.id, "sensore")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>  
        );

      case "structureMezzi":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      navigate("/logistica/mezzi/Manutenzione")
                      singleData(row?.id, "mezzi");
                      localStorage.setItem("mezzi_id", row?.id);
                      // console.log(row?.id);
                    }
                    }
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.name}</StyledTableCell>
                    <StyledTableCell>{row.tipo_mezzo}</StyledTableCell>
                    <StyledTableCell>{row.targa}</StyledTableCell>
                    {/* <StyledTableCell align="center">
                      {console.log("Row Status:", row.status)}
                  {console.log("Current Status:", currentStatuses?.[index])}
                      <StatusChip
                        stato={
                          searchFilters?.status && row.status
                            ? row.status
                            : currentStatuses?.[index] || row.status || "Unknown"
                        }
                        className={
                          getStatusColor(
                            searchFilters?.status && row.status
                              ? row.status
                              : currentStatuses?.[index] || row.status || "Unknown"
                          )?.className || ""
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleStatusClick(index);
                        }}
                      >
                        {searchFilters?.status && row.status
                          ? row.status
                          : currentStatuses?.[index] || row.status || "Unknown"}
                      </StatusChip>
                    </StyledTableCell> */}
                    <StyledTableCell>{row.anno_acquisto}</StyledTableCell>
                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row.id, "mezzi")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
      case "strucutreOperatori":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      navigate("")
                      singleData(row?.id, "operatori");
                      localStorage.setItem("strucutreOperatori", true);
                    }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.nome}</StyledTableCell>
                    <StyledTableCell>{row.cognome}</StyledTableCell>
                    <StyledTableCell>{row.email}</StyledTableCell>
                    <StyledTableCell>{row.abilitazioni}</StyledTableCell>

                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row.id, "operatori")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );

      case "produzioni":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      console.log(row?.id);
                      singleData(row?.id, "produzioni");
                      navigate("/produzione/vendemmia")
                    }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row?.ricette?.name || 'NA'}</StyledTableCell>
                    <StyledTableCell>{prodotti.map((item)=> item?.id === row?.ricette?.prodotto_id ? item.commercial_name : '')}</StyledTableCell>
                    <StyledTableCell align="center">
                      {/* {console.log("Row Status:", row.status)}
                  {console.log("Current Status:", currentStatuses?.[index])} */}
                      <StatusChip
                        stato={
                          searchFilters?.status && row.status
                            ? row.status
                            : currentStatuses?.[index] || row.status || "Unknown"
                        }
                        className={
                          getStatusColor(
                            searchFilters?.status && row.status
                              ? row.status
                              : currentStatuses?.[index] || row.status || "Unknown"
                          )?.className || ""
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleStatusClick(index);
                        }}
                      >
                        {searchFilters?.status && row.status
                          ? row.status
                          : currentStatuses?.[index] || row.status || "Unknown"}
                      </StatusChip>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {/* {console.log("Row Status:", row.status)}
                  {console.log("Current Status:", currentStatuses?.[index])} */}
                      <StatusChip
                        stato={
                          searchFilters?.status && row.status
                            ? row.status
                            : currentStatuses?.[index] || row.status || "Unknown"
                        }
                        className={
                          getStatusColor(
                            searchFilters?.status && row.status
                              ? row.status
                              : currentStatuses?.[index] || row.status || "Unknown"
                          )?.className || ""
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleStatusClick(index);
                        }}
                      >
                        {searchFilters?.status && row.status
                          ? row.status
                          : currentStatuses?.[index] || row.status || "Unknown"}
                      </StatusChip>
                    </StyledTableCell>
                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF 
                        id={row.id} 
                        options={option}
                        handleDelete = {() => handleDelete(row.id, "produzioni")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
      case "trasportoLogistica":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => { singleData(row?.id, "transport"); navigate("/logistica/trasporto/graph") }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.date_start}</StyledTableCell>
                    <StyledTableCell sx={{ color: "#999999", fontWeight: "700", lineHeight: "100%", fontSize: "14px" }}>{row.partenanza_da}</StyledTableCell>
                    <StyledTableCell>{row.date_end}</StyledTableCell>
                    <StyledTableCell sx={{ color: "#999999", fontWeight: "700", lineHeight: "100%", fontSize: "14px" }}>{row.destinazione_a}</StyledTableCell>
                    <StyledTableCell>{row.prodotto}</StyledTableCell>
                    <StyledTableCell>{row.qta_prodotto}</StyledTableCell>
                    <StyledTableCell>{row.status}</StyledTableCell>
                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row?.id, "trasproto")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
      case "documentiLogistica":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      navigate("")
                      singleData(row?.id, "documenti");
                      localStorage.setItem("documentiLogistica", true);
                    }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.doc_name}</StyledTableCell>
                    <StyledTableCell>{row.tipo_di_invento}</StyledTableCell>
                    <StyledTableCell>{row.scadenza}</StyledTableCell>
                    <StyledTableCell>{row.stato_intervento}</StyledTableCell>
                    {/* <StyledTableCell align="center">
                      {console.log("Row Status:", row.status)}
                      {console.log("Current Status:", currentStatuses?.[index])}
                      <StatusChip
                        stato={
                          searchFilters?.status && row.status
                            ? row.status
                            : currentStatuses?.[index] || row.status || "Unknown"
                        }
                        className={
                          getStatusColor(
                            searchFilters?.status && row.status
                              ? row.status
                              : currentStatuses?.[index] || row.status || "Unknown"
                          )?.className || ""
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleStatusClick(index);
                        }}
                      >
                        {searchFilters?.status && row.status
                          ? row.status
                          : currentStatuses?.[index] || row.status || "Unknown"}
                      </StatusChip>
                    </StyledTableCell> */}
                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row.id, "documenti")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );

      case "viaggiLogistica":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      navigate("/logistica/mezzi/Viaggi")
                      singleData(row?.id, "transport");
                      localStorage.setItem("viaggiLogistica", true);
                    }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.date_start}</StyledTableCell>
                    <StyledTableCell sx={{ color: "#999999", fontWeight: "700", lineHeight: "100%", fontSize: "14px" }}>{row.partenanza_da}</StyledTableCell>
                    <StyledTableCell>{row.date_end}</StyledTableCell>
                    <StyledTableCell sx={{ color: "#999999", fontWeight: "700", lineHeight: "100%", fontSize: "14px" }}>{row.destinazione_a}</StyledTableCell>
                    <StyledTableCell>{row.prodotto}</StyledTableCell>
                    <StyledTableCell>{row.qta_prodotto}</StyledTableCell>
                    <StyledTableCell>{row.status}</StyledTableCell>
                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row?.id, "trasproto")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
          // <TableBody>
          //   {data?.length > 0 ? (
          //     data
          //       .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          //       .map((row, index) => (
          //         <StyledTableRow
          //           key={index}
          //           selected={isSelected(row.id)}
          //           onClick={() => navigate("")}
          //         >
          //           <StyledTableCell align="center">
          //             <CustomCheckbox
          //               className="customChechbox"
          //               color="primary"
          //               checked={isSelected(row.id)}
          //               onChange={(event) => handleRowClick(event, row.id)}
          //               onClick={(event) => event.stopPropagation()}
          //               inputProps={{ "aria-labelledby": row.id }}
          //             />
          //           </StyledTableCell>
          //           <StyledTableCell sx={{ color: "#999999", fontWeight: "700", lineHeight: "100%", fontSize: "14px" }}>{row.partenzaIl}</StyledTableCell>
          //           <StyledTableCell>{row.luogoDiPartenza}</StyledTableCell>
          //           <StyledTableCell sx={{ color: "#999999", fontWeight: "700", lineHeight: "100%", fontSize: "14px" }}>{row.arrivoIl}</StyledTableCell>
          //           <StyledTableCell >{row.luogoDiArrivo}</StyledTableCell>
          //           <StyledTableCell>{row.prodotto}</StyledTableCell>
          //           <StyledTableCell>{row.quantitaProdotto}</StyledTableCell>
          //           <StyledTableCell align="">
          //             <StatusChip
          //               stato={
          //                 searchFilters?.stato
          //                   ? row.stato
          //                   : currentStatuses[index]
          //               }
          //               className={
          //                 getStatusColor(
          //                   searchFilters?.stato
          //                     ? row.stato
          //                     : currentStatuses[index]
          //                 ).className
          //               }
          //               onClick={(e) => {
          //                 e.preventDefault();
          //                 e.stopPropagation();
          //                 handleStatusClick(index);
          //                 // classActice(row.stato);
          //               }}
          //             >
          //               {searchFilters?.stato
          //                 ? row.stato
          //                 : currentStatuses[index]}
          //             </StatusChip>
          //           </StyledTableCell>
          //           <StyledTableCell
          //             // sx={{ textAlign: "center" }}
          //             onClick={(event) => event.stopPropagation()}
          //           >
          //             <MenuWithPDF options={option} />
          //           </StyledTableCell>
          //         </StyledTableRow>
          //       ))
          //   ) : (
          //     <StyledTableRow>
          //       <StyledTableCell colSpan={12} align="center">
          //         Data not found
          //       </StyledTableCell>
          //     </StyledTableRow>
          //   )}
          // </TableBody>
        );
      case "stabilimentiLogistica":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      navigate("/logistica/stabilimenti/Attrezzature")
                      // {console.log(row)}
                      localStorage.setItem("stabili_id", row?.id);
                      singleData(row?.id, "stabilimenti");
                    }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.nomeStabilimento}</StyledTableCell>
                    <StyledTableCell>{row.tipologia}</StyledTableCell>
                    <StyledTableCell>{row.supTotale}</StyledTableCell>
                    <StyledTableCell>{row.supCoperta}</StyledTableCell>
                    <StyledTableCell>{row.stoccaggio}</StyledTableCell>
                    <StyledTableCell>{row.impianti}</StyledTableCell>
                    <StyledTableCell>{row.coordinateGPS}</StyledTableCell>
                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row?.id, "stablimenti")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
      case "manutenzioneLogistica":
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => {
                      navigate("")
                      singleData(row?.id, "manutenzione");
                      localStorage.setItem("manutenzione", true);
                    }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.intervento}</StyledTableCell>
                    <StyledTableCell>{row.tipoDiIntervento}</StyledTableCell>
                    <StyledTableCell>{row.km_mezzo}</StyledTableCell>
                    <StyledTableCell>{row.dataIntervento}</StyledTableCell>
                    <StyledTableCell align="center">
                      {/* {console.log("Row Status:", row.status)}
                {console.log("Current Status:", currentStatuses?.[index])} */}
                      <StatusChip
                        stato={
                          searchFilters?.stato_intervento && row.stato_intervento
                            ? row.stato_intervento
                            : currentStatuses?.[index] || row.stato_intervento || "Unknown"
                        }
                        className={
                          getStatusColor(
                            searchFilters?.stato_intervento && row.stato_intervento
                              ? row.stato_intervento
                              : currentStatuses?.[index] || row.stato_intervento || "Unknown"
                          )?.className || ""
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleStatusClick(index);
                        }}
                      >
                        {searchFilters?.stato_intervento && row.stato_intervento
                          ? row.status
                          : currentStatuses?.[index] || row.stato_intervento || "Unknown"}
                      </StatusChip>
                    </StyledTableCell>
                    <StyledTableCell
                      // sx={{ textAlign: "center" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row?.id, "manutenzioneLogistica")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
      case "subTrattamentiProduction":

        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                    onClick={() => { singleData(row?.id, "produzione-trretmenti"); navigate(""); localStorage.setItem("production", true) }}
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.tipo_di_trattamento}</StyledTableCell>
                    <StyledTableCell>{row.name_of_produzione}</StyledTableCell>
                    <StyledTableCell>{row.produzione_id}</StyledTableCell>
                    <StyledTableCell>{row.date}</StyledTableCell>
                    <StyledTableCell>{row.product_used}</StyledTableCell>
                    <StyledTableCell>{row.pro_qty}</StyledTableCell>
                    <StyledTableCell>{row.mod_di_applicazione}</StyledTableCell>
                    <StyledTableCell>{operatri.find(item => item?.id === row?.operatore_id)?.name || ''}</StyledTableCell>
                    <StyledTableCell>{row.sicurezza}</StyledTableCell>
                    <StyledTableCell
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF
                        options={option}
                        id={row.id}
                        handleDelete={() => handleDelete(row?.id, "produzione-trretmenti")}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );


      default:
        return (
          <TableBody>
            {data?.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={index}
                    selected={isSelected(row.id)}
                  // onClick={() =>
                  //   window.location.href.includes("/vendite/preventivi")
                  //     ? navigate("/vendite/preventivi/sub-preventivi")
                  //     : navigate("/acquisti/preventivi/sub-preventivi")
                  // }
                  >
                    <StyledTableCell align="center">
                      <CustomCheckbox
                        className="customChechbox"
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleRowClick(event, row.id)}
                        onClick={(event) => event.stopPropagation()}
                        inputProps={{ "aria-labelledby": row.id }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.docType}</StyledTableCell>
                    <StyledTableCell>{row.numero}</StyledTableCell>
                    <StyledTableCell>{row.creatoIl}</StyledTableCell>
                    {form === "form2" || form === "form1" ? (
                      ""
                    ) : (
                      <StyledTableCell>{row.titolo}</StyledTableCell>
                    )}
                    {form === "form1" ? (
                      ""
                    ) : (
                      <StyledTableCell>
                        <IconButton
                          size="small"
                          sx={{
                            mr: 1,
                            color: "action.active",
                            fontSize: "15px",
                            "&:hover": { backgroundColor: "transparent" },
                          }}
                        >
                          <VisibilityOutlinedIcon
                            sx={{ "&:hover": { color: "#57C700" } }}
                            fontSize="small"
                          />
                          {row.clienti}
                        </IconButton>
                      </StyledTableCell>
                    )}
                    {form === "form2" || form === "form1" ? (
                      ""
                    ) : (
                      <StyledTableCell>
                        <IconButton
                          size="small"
                          sx={{
                            mr: 1,
                            color: "action.active",
                            fontSize: "15px",
                            "&:hover": { backgroundColor: "transparent" },
                          }}
                        >
                          <VisibilityOutlinedIcon
                            sx={{ "&:hover": { color: "#57C700" } }}
                            fontSize="small"
                          />
                          {row.fornitori}
                        </IconButton>
                      </StyledTableCell>
                    )}
                    <StyledTableCell>{row.data}</StyledTableCell>
                    <StyledTableCell>
                      <Avatar1 />
                    </StyledTableCell>
                    <StyledTableCell>{row.valore}</StyledTableCell>
                    <StyledTableCell>
                      <Avatar1 />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <StatusChip
                        sx={{ cursor: "pointer" }}
                        stato={
                          searchFilters?.stato
                            ? row.stato
                            : currentStatuses[index]
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleStatusClick(index);
                        }}
                      >
                        {searchFilters?.stato
                          ? row.stato
                          : currentStatuses[index]}
                      </StatusChip>
                    </StyledTableCell>
                    <StyledTableCell
                      onClick={(event) => event.stopPropagation()}
                    >
                      <MenuWithPDF options={option} />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={12} align="center">
                  Data not found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        );
    }
  };

  return (
    <>
      {dataRender(navData)} {/* Calling the function */}
    </>
  );
};

export default TableRows;
